import { useHistory, useRouteMatch } from "react-router-dom";
import SideNav, { MenuItem } from "../../../components/SideNav";
import { useAuthentication } from "../../../reducer/authentication";

export default function TicketsSideNav() {
    const match = useRouteMatch();
    const history = useHistory();
    const { user } = useAuthentication();

    function handleClick(item: MenuItem) {
        if (item.id !== '' && match) {
            const url = match.path + '/' + item.id;
            history.push(url);
        }
    };

    const newMenu: MenuItem[] = [
        { id: 'newComments', name: 'Comentários não visualizados', type: 'TicketMyObsPending' },
        { id: 'open', name: 'Chamados abertos', type: 'TicketOpen' },
        { id: 'closed', name: 'Chamados Fechados', type: 'TicketClosed' },
        { id: 'add', name: 'Adicionar chamado', type: 'AddTicket' }
    ];

    return (
        <SideNav
            onNodeClick={handleClick}
            tree={newMenu}
        />
    );
}